// removed by extract-text-webpack-plugin
module.exports = {"base":"Gold_base--1r0ee","base__isNotEnough":"Gold_base__isNotEnough--i8VPN","baseIsNotEnough":"Gold_base__isNotEnough--i8VPN","base__size-small":"Gold_base__size-small--3M4Hg","baseSizeSmall":"Gold_base__size-small--3M4Hg","base__size-large":"Gold_base__size-large--2HFhW","baseSizeLarge":"Gold_base__size-large--2HFhW","base__isDisabled":"Gold_base__isDisabled--UMI9o","baseIsDisabled":"Gold_base__isDisabled--UMI9o","base__before":"Gold_base__before--Jt_Ko","baseBefore":"Gold_base__before--Jt_Ko","base__after":"Gold_base__after--2Um1n","baseAfter":"Gold_base__after--2Um1n"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Gold/Gold.css
// module id = 1770
// module chunks = 16